var map = {
	"./facebook.svg": 72803,
	"./instagram.svg": 63233,
	"./linkedin.svg": 87541,
	"./tiktok.svg": 56793,
	"./truth-social.svg": 11546,
	"./twitter.svg": 92588,
	"./youtube.svg": 47858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62452;